import { render } from "./ValidarDiaExtra.vue?vue&type=template&id=17797638&scoped=true"
import script from "./ValidarDiaExtra.vue?vue&type=script&lang=js"
export * from "./ValidarDiaExtra.vue?vue&type=script&lang=js"

import "./ValidarDiaExtra.vue?vue&type=style&index=0&id=17797638&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17797638"]])

export default __exports__